import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import queryString from "query-string";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Select from "react-select";

import axios from "../../../../axios-instance";
import Container from "../../../../components/UI/Container/Container";
import Page404 from "../../../../components/Page404/Page404";
import NewLoader from "../../../../components/NewLoader/NewLoader";
import PleaseWait from "../../../../images/please-wait-season-pass-modal.svg";

import "../SeasonPassPersonalInfo.sass";
import Icon from "../../../../components/UI/Icon/Icon";
import { paymentMethods } from "../../constants";
import { getCurrencieLabel } from "../../../../constants/currencies";
import { getTokenFormPaymentApi } from "../../../../helpers/getTokenFormPaymentApi";
import { getCurrentLanguageTexts, languagesList, setLangCode } from "../../../../constants/seasonPassPersonalInfoLangs";
import { MembershipCardContainer } from "../MembershipCard";

import { editMembeshipCardInfo, getMemberCards } from "../../../../store/actions/memberActions";
import { BuyAllSeasonPassesModal } from "../Modals/BuyAllSeasonPassesModal";
import ls from 'localstorage-slim';

import 'react-phone-input-2/lib/style.css';
import { executePayment } from "../../../../helpers/paymentHelper/paymentHelper.ts";
import { paymentTypes } from "../../../../constants/paymentType.ts";
import { handleOrderStatus } from "../../../../components/Sells/Modals/statusModals.js";
import { getOc } from "../../../../helpers/optionalChain.ts";

const MySwal = withReactContent(Swal);

export const MemberCards = ({
    dispatch,
    membershipList,
    getMemberCards,
    editMembeshipCardInfo,
    handleChangeLang,
    lang,
    ...params
}) => {
    const [isLoadingState, setIsLoadingState] = useState(true);
    const [isMemberFound, setIsMemberFound] = useState(false);
    const [isEventDataLoading, setIsEventDataLoading] = useState(false);

    const blockRef = useRef(null);
    const [blockWidth, setBlockWidth] = useState('300px');

    const [currencyCode, setCurrencyCode] = useState("RSD");
    const [eventData, setEventData] = useState(null);
    const [seasonEventData, setSeasonEventData] = useState(null);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [gender, setGender] = useState(null);
    const [streetAndHouseNumber, setStreetAndHouseNumber] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [isPersonalDataChanged, setPersonalDataChanged] = useState(false);

    const [accessTokenFromPaymentApi, setAccessTokenTokenFromPaymentApi] =
        useState("");

    const [points, setPoints] = useState("");
    const [seasonPassList, setSeasonPassList] = useState([]);
    const [resaleRequestsList, setResaleRequestsList] = useState([]);
    const [isPendingToApprove, setIsPendingToApprove] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [birthday, setBirthday] = useState(null);
    const [memberStatus, setMemberStatus] = useState(null);

    const [holdedSeats, setHoldedSeats] = useState([]);

    const [pickerData, setPickerData] = useState({
        year: null,
        month: null,
        days: null,
    });

    const txt = getCurrentLanguageTexts();

    const isCashPaymentMode = ls.get('pageAction') === 'selling';
    const pageAction = queryString.parse(params.location.search).action;

    const token = ls.get('member-access-token', '');

    const authResult = queryString.parse(params.location.search)["?authResult"];

    const openBuyAllModal = async () => {
        const seatsToBuy = membershipList.filter(t => !t.hasSeasonPass && !!t.seat)

        const { data: eventData } = await axios.get(`EventPublicInfo/BySlug/${process.env.REACT_APP_NEW_SEASON_EVENT_SLUG}`);
        const { data } = await axios.post(`TicketTemplate/${process.env.REACT_APP_NEW_SEASON_EVENT_ID}/by-seats`,
            seatsToBuy.map(c =>
                c.area + (!!c.side ? `-${c.side}` : '') + `-${c.row}-${c.seat}`)
        )

        MySwal.fire({
            html: (
                <BuyAllSeasonPassesModal
                    membershipCards={seatsToBuy}
                    availablePoints={0} // disabled for invoices
                    onConfirmBuySeasonPass={onConfirmBuySeasonPass}
                    event={eventData}
                    selectedTicketTemplates={data}
                    title={txt.BuyAllSeasonPassesModalTxt['title']}
                />
            ),
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "public-user-modal member-page-modal",
        });
    };

    const showPleaseWaitModal = () => {
        MySwal.fire({
            imageUrl: PleaseWait,
            title: waitModalTxt.title,
            text: waitModalTxt.description,
            allowEscapeKey: false,
            customClass: "partizan-modal seasonpass__modal partizan-info-modal",
            allowOutsideClick: false,
            allowEnterKey: false,
            showConfirmButton: false,
        });
    };

    const getEventData = async () => {
        setIsEventDataLoading(true);
        const memberEventSlug = process.env.REACT_APP_MEMBER_EVENT_SLUG;
        const { data } = await axios.get(`/EventPublicInfo/BySlug/${memberEventSlug}`);

        const seasonData = await axios.get(`/EventPublicInfo/BySlug/${process.env.REACT_APP_NEW_SEASON_EVENT_SLUG}`);
        const paymentApiRes = await getTokenFormPaymentApi({
            merchantId: data.merchantId,
        });
        if (paymentApiRes) {
            setAccessTokenTokenFromPaymentApi(paymentApiRes.data.access_token);
        }
        setCurrencyCode(
            getCurrencieLabel(data.currencyId)
        );
        if (isCashPaymentMode) {
            seasonData.data.fee = {
                rate: 0,
                fixedByPosition: 0,
                fixedByOrder: 0,
            };
            data.fee = {
                rate: 0,
                fixedByPosition: 0,
                fixedByOrder: 0,
            };
        }
        setEventData(data);
        setSeasonEventData(seasonData.data);
        setIsEventDataLoading(false);
    };

    const getOrderData = async () => {
        const urlParams = new URL(window.location.href).searchParams;
        let orderId = urlParams.get('resultOrderId');

        if (!!orderId) {
            if (orderId.indexOf('?') > 0) {
                orderId = orderId.substring(0, orderId.indexOf('?'))
            }

            const { data } = await axios.get(
                `Order/${orderId}?byTransactionId=true`);

            handleOrderStatus({
                status: data.status,
                orderId,
                buyerEmail: data.info.buyerEmail,
                additionalPaymentStatus: data.externalStatus,
                paymentData: data.paymentDate,
                buyMoreUrl: window.location.pathname,
                authCode: getOc(data, '?.info?.kopaInfo?.authCode', ' '),
                reloadData: getOrderData,
            })
        }
    }

    const createOrder = async (tickets, fullName, totalPrice, pointsToDiscount, companyInfo, fields = null) => {
        showPleaseWaitModal();

        const onlinePayment = !companyInfo.companyName;
        let paymentType = onlinePayment ? paymentTypes.online : paymentTypes.delayedPayment;

        await executePayment({
            eventData: seasonEventData,
            paymentProvider: isCashPaymentMode ? paymentMethods.OffPay : paymentMethods.LedPay,
            paymentType: paymentType,
            redirectUrl: window.location.href.includes('?') ? window.location.href + "&resultOrderId={Id}"
                : window.location.href + "?resultOrderId={Id}",
            couponCode: `RESALE_POINTS_${pointsToDiscount}`,
            tickets: tickets,
            transaction: {
                fullName: fullName,
                physicalAddress: streetAndHouseNumber,
                city,
                postalCode,
                phoneNumber: phone,
                buyerEmail: email,
                birthday: birthday,
                gender: gender,
                buyerCountry: 'Srbija',
                transactionFieldValues: !fields
                ? []
                : seasonEventData.transactionFields
                    .filter((f) => f.type === 0)
                    .map((f) => ({
                      value: fields[f.name] || '',
                      transactionAddtitionalFieldId: f.id,
                    })),
                ...companyInfo
            }
        });

        if (!onlinePayment) {
            MySwal.close();
            toast.success(txt.BuySeasonPassModalTxt.success)
        }
    }

    const onConfirmBuySeasonPass = async (seats, fullName, totalPrice, pointsToDiscount, { companyName = '', companyCity = '', companyAddress = '', companyVatNumber = '', companyCountry = '' }, fields) => {
        createOrder(seats, fullName, totalPrice, pointsToDiscount, { companyName, companyCity, companyAddress, companyVatNumber, companyCountry }, fields);
    }

    const loadSeasonPassMember = async () => {
        await axios
            .get(`/SeasonPassMember?accessToken=${token}`)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    setFirstname(response.data.firstName);
                    setLastname(response.data.lastName);
                    setEmail(response.data.email);
                    setPhone(response.data.phoneNumber);
                    setGender(response.data.gender);
                    setStreetAndHouseNumber(response.data.physicalAddress);
                    setCity(response.data.city);
                    setPostalCode(response.data.postalCode);
                    setResaleRequestsList(response.data.resaleRequests);
                    setPoints(response.data.points);
                    setIsPendingToApprove(response.data.status === 2);
                    setMemberStatus(response.data.status);

                    if (response.data.dateOfBirth && response.data.dateOfBirth !== "0001-01-01T00:00:00") {
                        setPickerData({
                            year: moment(response.data.dateOfBirth).year(),
                            month: moment(response.data.dateOfBirth).month(),
                            days: +moment(response.data.dateOfBirth).format("D"),
                        });
                        setBirthday(response.data.dateOfBirth);
                    }

                    //handleLang(response.data.lang);
                    if (response.data.status === 3) {
                        getEventData();
                        getOrderData();
                        setIsApproved(true);
                    }
                    localStorage.setItem('user_' + response.data.email.toLowerCase().trim(), token);
                    setIsMemberFound(true);
                    setIsLoadingState(false);

                    if (pageAction === 'edit') {
                        setIsPendingToApprove(false);
                        setIsApproved(false);
                    }
                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
                setIsLoadingState(false);
                setIsMemberFound(false);
            });

        await axios
            .get(`/Membership/passes?accessToken=${token}`)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    const list = response.data.filter(
                        (season) => season.requestedToUpdate
                    );

                    setSeasonPassList(list);
                    setIsMemberFound(true);
                    setIsLoadingState(false);
                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
                setIsLoadingState(false);
                setIsMemberFound(false);
            });

        await axios
            .get(`/Membership/holdedSeats?accessToken=${token}`)
            .then((response) => {
                setHoldedSeats(response.data);
            }).catch((err) => {
                setIsLoadingState(false);
                setIsMemberFound(false);
            });
    };

    useEffect(() => {
        if (token) {
            getMemberCards(token, process.env.REACT_APP_MEMBER_EVENT_ID);
        }

        if (pageAction === 'edit') {
            setPersonalDataChanged(true);
        }
    }, [token]);

    const { waitModalTxt, SeasonPassListTxt } = getCurrentLanguageTexts();

    useEffect(() => {
        loadSeasonPassMember();
    }, [authResult]);

    useEffect(() => {
        if (blockRef.current) {
            setBlockWidth(
                getComputedStyle(blockRef.current).width
            )
        }
    }, [blockRef.current]);

    useEffect(() => {
        window.addEventListener('beforeunload', (event) => {
            MySwal.close();
            setIsLoadingState(true);
        });

        window.addEventListener('pageshow', event => {
            if (event.persisted) {
                window.location.reload();
            }
        });
    }, [])

    if (isLoadingState || isEventDataLoading) {
        return <NewLoader />;
    }

    if (!isMemberFound) {
        return <Page404 isBackBtn={false} isRefreshAvailable={true} />;
    }

    const allowInvoices = membershipList.filter(m => !m.hasSeasonPass && m.hasDefaultSeat && m.allowBuySeasonPass).length > 0;

    return (
        <Container className="seasonpass seasonpass-pers-info">

            <div className="seasonpass-pers-info__logo seasonpass-pers-info__header-logo-wrapper">
                {/* <img src={PartizanOpenSellingLogo} alt="Logo" />
        <h2>SixTix</h2> */}
            </div>
            <div className="seasonpass-pers-info__main-block">
                <Select
                    options={languagesList}
                    name="language"
                    value={languagesList.find(({ value }) => lang === value)}
                    onChange={handleChangeLang}
                    classNamePrefix="partizan-open-selling__select"
                    className="partizan-open-selling__select partizan-open-selling__select--lang"
                />

                {isPendingToApprove ? (
                    <div className="seasonpass-pers-info__notification">
                        <Icon name="clock-white" />
                        <h4>{waitModalTxt.waitingForReview}</h4>
                    </div>
                ) : null}

                {isApproved && (
                    <>
                        <h2 className="first-title first-title--member-main">{SeasonPassListTxt.title}</h2>

                        <MembershipCardContainer
                            onSave={(payload) => editMembeshipCardInfo(token, payload)}
                            membershipCards={membershipList}
                            holdedSeats={holdedSeats}
                            currencyLabel={currencyCode}
                            onConfirmBuySeasonPass={onConfirmBuySeasonPass}
                            availablePoints={isCashPaymentMode ? 0 : points}
                            eventInfo={seasonEventData}
                            memberEventInfo={eventData}
                            langCode={lang}
                            onConfirmBuyNfc={onConfirmBuySeasonPass}
                            ableToBuyNFC={true} />

                        {allowInvoices && !!membershipList.length &&
                            <button className="btn-primary buy-all"
                                onClick={openBuyAllModal}>{txt.SeasonPassListTxt['buyViaInvoice']}</button>
                        }
                    </>
                )}
            </div>
        </Container>
    );
};

const mapStateToProps = ({ member }) => ({
    membershipList: member.membershipList,
});
const mapDispatchToProps = (dispatch) => ({
    getMemberCards: (accessToken, eventId) =>
        dispatch(getMemberCards(accessToken, eventId)),
    editMembeshipCardInfo: (accessToken, ticket) =>
        dispatch(editMembeshipCardInfo(accessToken, ticket)),
    dispatch: (foo) => dispatch(foo),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberCards)